import { useMutation } from '@tanstack/react-query';

import { reportingLeDataSessionFeedbackPath } from '~/consts/reportingLeDataApi';

import { json_headers, request } from '~/services/common';

import type { LeDataFeedbackRating } from '~/types/leData';

import { resolveReportingLeDataUrl } from '~/utils/resolveReportingLeDataUrl';

type SubmitFeedbackInput = {
  sessionId: string;
  rating: LeDataFeedbackRating;
  /** le-data trace id of the answer being rated; the server resolves the latest trace for the session when omitted. */
  traceId?: string;
  comment?: string;
};

type SubmitFeedbackResponse = {
  ok?: boolean;
  feedbackId?: string;
};

/** POST `/api/reporting/le-data/sessions/:sessionId/feedback` with `{ rating, traceId?, comment? }`. */
export function useSubmitReportingLeDataFeedback() {
  return useMutation({
    mutationFn: async ({ sessionId, rating, traceId, comment }: SubmitFeedbackInput) => {
      const url = resolveReportingLeDataUrl(reportingLeDataSessionFeedbackPath(sessionId));
      const body: Record<string, unknown> = { rating };
      if (traceId) {
        body.traceId = traceId;
      }
      if (comment?.trim()) {
        body.comment = comment.trim();
      }
      return (await request(url, {
        method: 'POST',
        headers: json_headers,
        body: JSON.stringify(body),
      })) as SubmitFeedbackResponse;
    },
  });
}
